import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'src/shadcn/components/ui/dialog';
import * as React from 'react';
import { SelectCar } from 'src/Components/AddNewCustomerWizard/SelectCar';
import { gql } from '@apollo/client';
import { SelectCarModalFragment } from './__generated__/SelectCarModal.generated';

export interface ISelectCarModalProps {
  setIsOpen: (newIsOpen: boolean) => void;
  isOpen: boolean;
  onSelectCar: (car: SelectCarModalFragment) => void;
  customerId: string;
  carIdToHide?: string;
}

export const SelectCarModal: React.FunctionComponent<
  ISelectCarModalProps
> = props => {
  return (
    <Dialog open={props.isOpen} onOpenChange={props.setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{'Select a vehicle'}</DialogTitle>
        </DialogHeader>
        <SelectCar {...props} />
      </DialogContent>
    </Dialog>
  );
};

const fragment = gql`
  fragment SelectCarModal on Car {
    id
    year
    make
    model
    colour
    vin
    licensePlate
    createdAt
  }
`;
